import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import Login from '../components/users/auth';
import AddUser from '../components/users/add';
import UserDashBoard from '../containers';
import App from '../App';
import * as actions from '../actions';
import {connect} from 'react-redux';

class Routes extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {token, account} = this.props;

        return (
            <Router history={this.props.historyBrowser}>
                <div>
                    <Route
                        exact
                        path="/"
                        render={() => (token === ""
                            ? (<Redirect to="/login"/>)
                            : (<App/>))}/>
                    <Route
                        path="/issue/:issueID"
                        render={(route) => (token === ""
                            ? (<Redirect to="/login"/>)
                            : (<App route={route}/>))}/>
                    <Route
                        path="/user"
                        render={() => (token === ""
                            ? (<Redirect to="/login"/>)
                            : (<UserDashBoard/>))}/>
                    <Route path="/login" component={Login}/>
                </div>
            </Router>
        );
    }
}

export default connect(({token, account}) => ({token, account}))(Routes);


// WEBPACK FOOTER //
// ./src/routers/routes.js